import React, { useState } from 'react';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

import { formatDate } from 'helpers/date';

const tooltipWrapperStyles = {
  backgroundColor: 'rgba(0,0,0,.85)',
  fontsize: '14px',
  color: '#fff',
  borderRadius: '4px',
};

const UnloadingPercChart = ({ stats, syncId, tzOffset, ...rest }) => {
  const [visibility, setVisibility] = useState({
    unloadPercFormatted: true,
    unloadedForcastedPercFormatted: true,
    imgQuality: true,
  });

  let percMax = 100;
  const data = (stats || []).map(stat => {
    stat = { ...stat };
    stat.unloadPercFormatted = ((stat.unloaded_percent || 0) * 100).toFixed(2);
    stat.unloadedForcastedPercFormatted = ((stat.unloaded_percent_duration_estimated || 0) * 100).toFixed(2);
    stat.imgQuality = Number(stat.last10min_img_quality || 0).toFixed(3);
    
    percMax = Math.max(
      percMax,
      stat.unloadPercFormatted,
      stat.unloadedForcastedPercFormatted
    );
    return stat;
  });

  percMax = Math.ceil(percMax);

  return (
    <ResponsiveContainer width="100%" height={350} {...rest}>
      <LineChart data={data} syncId={syncId}>
        <CartesianGrid strokeDasharray="3 3" stoke="#E7F3F8" />
        <XAxis dataKey="dt_datetime" minTickGap={15} tickMargin={10} stroke="#2F454E" height={30} tickFormatter={value => {
          return formatDate(Date.parse(value), 'HH:mm', {
            tzOffset
          });
        }} />

        <YAxis type="number" yAxisId="perc" unit="%" stroke="#2F454E" strokeWidth="1" domain={[0, percMax]}>
          {/* <Label value="Percentage" position="insideLeft" angle={-90} /> */}
        </YAxis>

        <YAxis type="number" yAxisId="quality" stroke="#2F454E" strokeWidth="1" orientation="right" domain={[0, 1]}></YAxis>

        <Tooltip contentStyle={tooltipWrapperStyles}
          labelFormatter={label => formatDate(Date.parse(label), 'yy-MM-dd HH:mm', {
            tzOffset
          })}
        />
        <Legend verticalAlign="top" height={36} onClick={({ dataKey }) => {
          setVisibility({ ...visibility, [dataKey]: !visibility[dataKey] });
        }}/>

        <Line yAxisId="perc" name="Unloaded" type="monotone" hide={!visibility.unloadPercFormatted} dataKey="unloadPercFormatted" dot={false} activeDot={true} stroke="#42B0D5" strokeWidth="2" unit="%" />
        <Line yAxisId="perc" name="Predicted" type="monotone" hide={!visibility.unloadedForcastedPercFormatted} dataKey="unloadedForcastedPercFormatted" dot={false} activeDot={true} stroke="#52C41A" strokeWidth="2" unit="%" />
        <Line yAxisId="quality" name="Last10Min Img Quality" type="monotone" hide={!visibility.imgQuality} dataKey="imgQuality" dot={false} activeDot={true} stroke="#85A5FF" strokeWidth="2" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default UnloadingPercChart;
